module.exports = __webpack_public_path__ + "img/Background.f37b49cb.jpg";